import React, { PureComponent } from 'react';
import { Link } from "react-router-dom";
import { getTokenLogin } from 'utils/storage';
import "./index.scss";


export default class Entry extends PureComponent {

    goPage(e) {
        window.open(e);
    }


    componentDidMount() {
        const token = getTokenLogin()
        console.log("token:", token)
    }

    render() {
        return (

            <div className="main">
                <div className="entry_container">
                    <div className="clear extraordinary">
                        <div className="entry_link">
                            {/* <Link to="/entrance/home"></Link> */}
                            <a onClick={() => this.goPage('/entrance/home')}></a>
                        </div>
                        <div className="entry_link">
                            {/* <Link to="/page"></Link> */}
                            <a onClick={() => this.goPage('http://yhbest.imwork.net:38000')}></a>
                        </div>
                        <div className="entry_link">
                            <a onClick={() => this.goPage('http://yhbest.imwork.net:38000')}></a>
                        </div>
                        <div className="entry_link">
                            <a onClick={() => this.goPage('http://yhbest.imwork.net:38000')}></a>
                        </div>
                        <div className="entry_link">
                            <a onClick={() => this.goPage('http://121.31.6.5:8890/#/hainanEmployment')}></a>
                        </div>
                        <div className="entry_link">
                            {/* 统一基础支撑平台 */}
                            <a onClick={() => this.goPage('http://yhbest.imwork.net:38000/user/login')}></a>
                        </div>
                    </div>
                    <div className="codes">
                        <div className="code">
                            <div><div className="code-txt">退役军人APP</div></div>
                        </div>
                        <div className="code">
                            <div><div className="code-txt">关注微信公众号</div></div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}